import styled from 'styled-components';

import { themeSpace } from 'styles/themeUtils';

export const List = styled.ul`
  li + li {
    margin-top: ${themeSpace(2)};
  }
`;

List.displayName = 'List';
